import * as React from 'react';

export const phFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_361)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#CF0921'
            />
            <mask
                id='mask0_1_361'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_361)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V10.6667H0V0Z'
                    fill='#0035A9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0V20.044L13.3333 10L0 0Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M3.33334 14.6667C3.70153 14.6667 4.00001 14.3682 4.00001 14C4.00001 13.6318 3.70153 13.3333 3.33334 13.3333C2.96515 13.3333 2.66667 13.6318 2.66667 14C2.66667 14.3682 2.96515 14.6667 3.33334 14.6667Z'
                    fill='#FFDA2C'
                />
                <path
                    d='M9.99999 10.6667C10.3682 10.6667 10.6667 10.3682 10.6667 10C10.6667 9.63182 10.3682 9.33334 9.99999 9.33334C9.63181 9.33334 9.33333 9.63182 9.33333 10C9.33333 10.3682 9.63181 10.6667 9.99999 10.6667Z'
                    fill='#FFDA2C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M5.98001 10.6467C7.14001 10.5733 8.00001 10.3133 8.00001 10C8.00001 9.68801 7.14001 9.42668 5.98001 9.35334C5.90667 8.19334 5.64667 7.33334 5.33334 7.33334C5.02134 7.33334 4.76001 8.19334 4.68667 9.35334C3.52667 9.42668 2.66667 9.68668 2.66667 10C2.66667 10.312 3.52667 10.5733 4.68667 10.6467C4.75867 11.8067 5.02001 12.6667 5.33334 12.6667C5.64534 12.6667 5.90667 11.8067 5.98001 10.6467Z'
                    fill='#FFDA2C'
                />
                <path
                    d='M3.33334 6.66668C3.70153 6.66668 4.00001 6.3682 4.00001 6.00001C4.00001 5.63182 3.70153 5.33334 3.33334 5.33334C2.96515 5.33334 2.66667 5.63182 2.66667 6.00001C2.66667 6.3682 2.96515 6.66668 3.33334 6.66668Z'
                    fill='#FFDA2C'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_361'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
